import a from "./ghl-ui.es403.js";
import i from "./ghl-ui.es422.js";
import n from "./ghl-ui.es1421.js";
var e = Object.prototype, p = e.hasOwnProperty;
function v(r) {
  if (!a(r))
    return n(r);
  var s = i(r), o = [];
  for (var t in r)
    t == "constructor" && (s || !p.call(r, t)) || o.push(t);
  return o;
}
export {
  v as default
};
